import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    vapidPublicKey: String
  }

  async connect() {
    if (!("serviceWorker" in navigator)) return
    if (!("PushManager" in window)) return

    const registration = await navigator.serviceWorker.ready
    const subscription = await registration.pushManager.getSubscription()

    if (subscription) {
      await this.sendSubscriptionToServer(subscription)
    } else {
      console.log("Not subscribed to push notifications")
    }
  }

  async subscribe() {
    if (!("serviceWorker" in navigator)) {
      alert("Push notifications are not supported in this browser or requires HTTPS.")
      return
    }

    try {
      // 2. Request permission explicitly if not already granted
      if (Notification.permission === "default") {
        const permission = await Notification.requestPermission()
        if (permission !== "granted") {
          console.log("Permission not granted")
          return
        }
      }

      const registration = await navigator.serviceWorker.ready

      // Check if a subscription already exists
      let subscription = await registration.pushManager.getSubscription()

      if (subscription) {
        // Unsubscribe if it exists to avoid "different applicationServerKey" errors
        // especially common when switching between local dev projects on localhost:3000
        await subscription.unsubscribe()
      }

      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: this.urlBase64ToUint8Array(this.vapidPublicKeyValue)
      })

      await this.sendSubscriptionToServer(subscription)
      alert("Push notifications enabled!")
    } catch (error) {
      console.error("Failed to subscribe to push notifications", error)
    }
  }

  async sendSubscriptionToServer(subscription) {
    const { endpoint, keys } = subscription.toJSON()

    await fetch("/users/web_push_subscriptions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        subscription: {
          endpoint,
          keys
        }
      })
    })
  }

  urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4)
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/")

    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray
  }
}
